module.exports = __webpack_public_path__ + "media/horror-short.15e9c57b.mp4";